import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useContainerStyles } from '../styles/container';
import Title from './Title';
import MapImage from '../../../images/features/hida/map.png';
import CircleGrid from './CircleGrid';
import Hidden from '@material-ui/core/Hidden';
import Grid from '@material-ui/core/Grid';
import Description from './Description';
import clsx from 'clsx';
import BusinessList from './BusinessList';
import Access from './Access';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.props.backgroundColor,
    width: '100%',
    paddingBottom: theme.spacing(5),
    [theme.breakpoints.up('sm')]: {
      marginTop: -112,
      paddingTop: 112,
      padding: theme.spacing(8, 0, 8),
    },
    '& > *': {
      paddingBottom: '0 !important',
    },
  },
  mapContainer: {
    display: 'flex',
    flexWrap: 'nowrap',
    justifyContent: 'center',
    width: 'calc(100% - 100px)',
    maxWidth: 1000,
    margin: theme.spacing(0, 'auto'),
  },
  circle: {
    width: '100%',
    maxWidth: 200,
  },
  map: {
    width: '100%',
    maxWidth: 400,
    height: 'auto',
    padding: theme.spacing(5, 4),
    margin: 'auto',
    [theme.breakpoints.up('lg')]: {
      padding: 0,
    },
  },
  line: {
    [theme.breakpoints.only('xs')]: {
      '& > *': {
        borderBottom: '2px dotted #E8D6B3',
      },
    },
  },
}));

const Place = ({ businesses = [], plans = [], isAuthenticated }) => {
  const containerClasses = useContainerStyles();
  const classes = useStyles();

  const firstCircleGrid = React.useMemo(
    () => <CircleGrid index={[0, 1]} />,
    [],
  );
  const secondCircleGrid = React.useMemo(
    () => <CircleGrid index={[2, 3]} />,
    [],
  );
  const map = <img src={MapImage} style={{ width: '100%', height: 'auto' }} />;

  return (
    <div className={classes.root}>
      <div className={containerClasses.root}>
        <Title text="WHAT’S HIDA?">飛騨市ってどんなところ？</Title>
        <Hidden implementation="css" smDown>
          <div className={classes.mapContainer}>
            <div className={classes.circle} style={{ marginRight: 'auto' }}>
              {firstCircleGrid}
            </div>
            <div className={classes.map}>{map}</div>
            <div className={classes.circle} style={{ marginLeft: 'auto' }}>
              {secondCircleGrid}
            </div>
          </div>
        </Hidden>
        <Hidden implementation="css" mdUp>
          <div className={classes.map}>{map}</div>
          <Grid container spacing={3} justify="center">
            <Grid item xs={6} className={classes.circle}>
              {firstCircleGrid}
            </Grid>
            <Grid item xs={6} className={classes.circle}>
              {secondCircleGrid}
            </Grid>
          </Grid>
        </Hidden>
      </div>
      <div className={clsx(containerClasses.root, classes.line)}>
        <div />
      </div>
      <div className={containerClasses.root}>
        <Description />
      </div>
      <div className={containerClasses.root}>
        <BusinessList
          businesses={businesses}
          plans={plans}
          isAuthenticated={isAuthenticated}
        />
      </div>
      <div className={containerClasses.root}>
        <Access />
      </div>
    </div>
  );
};

export default Place;
